<div class="centro-custos-container">
  <div class="header d-flex justify-content-between align-items-center mb-3">
    <h1>Centro de Custos</h1>
    <button class="btn btn-primary" (click)="novo(modalCadastro)">
      <i class="fa fa-plus"></i> Adicionar novo
    </button>
  </div>

  <div class="card-box">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Id</th>
            <th>Nome</th>
            <th>Descrição</th>
            <th>Ativo</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itens">
            <td>{{ item.id }}</td>
            <td>{{ item.nome }}</td>
            <td>{{ item.descricao || '-' }}</td>
            <td>{{ item.ativo ? 'Sim' : 'Não' }}</td>
            <td>
              <button class="btn btn-outline-primary btn-sm mr-1" (click)="editar(item, modalCadastro)">
                <i class="fas fa-edit mr-1"></i>Editar
              </button>
              <button class="btn btn-outline-danger btn-sm" (click)="excluir(item)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="itens.length === 0">
            <td colspan="5" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #modalCadastro let-modal>
    <div class="modal-header">
      <h5 class="modal-title">{{ editandoId > 0 ? 'Editar Centro de Custo' : 'Novo Centro de Custo' }}</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row g-3">
        <div class="col-12">
          <label class="form-label">Nome *</label>
          <input type="text" class="form-control" [(ngModel)]="nome" />
        </div>
        <div class="col-12">
          <label class="form-label">Descrição</label>
          <textarea class="form-control" rows="3" [(ngModel)]="descricao"></textarea>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input id="ativoCentroCusto" class="form-check-input" type="checkbox" [(ngModel)]="ativo" />
            <label for="ativoCentroCusto" class="form-check-label">Ativo</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button class="btn btn-success" (click)="salvar()">Salvar</button>
    </div>
  </ng-template>
</div>
